import { store$ } from '@redux/store';
import { distinctUntilChanged, filter, skip, switchMap } from 'rxjs';
import { selectBrandId, selectCity, selectMarketId, selectSearchCommandContext } from 'features/searchResultsFacets';
import getLinkModulesContentRequest$ from 'api/getLinkModulesContent';

const updateLinkModules = (linkModulesHtml) => {
  const linkModulesContainer = document.querySelector('[data-link-modules]');
  
  if (!linkModulesContainer || !linkModulesHtml) {
    return;
  }

  const fragment = document.createRange().createContextualFragment(linkModulesHtml);
  linkModulesContainer.replaceWith(fragment);
};

/**
 * isSameLinkModulesContext: Checks if the relevant search parameters for link modules have changed.
 * @param {Object} previousState Previous store state.
 * @param {Object} currentState Current store state.
 * @returns {boolean} True if marketId, city and brandId are all unchanged.
 */
function isSameLinkModulesContext(previousState, currentState) {
  return selectMarketId(previousState) === selectMarketId(currentState) &&
         selectCity(previousState) === selectCity(currentState) &&
         selectBrandId(previousState) === selectBrandId(currentState);
}

/**
 * hasLinkModulesContext: Checks if any of the trigger parameters are set in the current state.
 * @param {Object} state Current store state.
 * @returns {boolean} True if at least one of marketId, city or brandId is present.
 */
function hasLinkModulesContext(state) {
  return Boolean(selectMarketId(state) || selectCity(state) || selectBrandId(state));
}

const onLocationChange$ = store$.pipe(
  distinctUntilChanged(isSameLinkModulesContext),
  skip(1),
  filter(hasLinkModulesContext)
);

const onLinkModulesReady$ = onLocationChange$.pipe(
  switchMap((state) => {
    const { searchParameters } = selectSearchCommandContext(state);

    return getLinkModulesContentRequest$(searchParameters);
  })
);

onLinkModulesReady$.subscribe(updateLinkModules);